<div class="solutions-people-browse">
  @if (filtersSheetOpen()) {
    <button
      type="button"
      class="solutions-people-browse__backdrop"
      (click)="closeFiltersSheet()"
      [attr.aria-label]="'global.close' | translate"></button>
  }

  <aside
    class="solutions-people-browse__filters"
    [class.solutions-people-browse__filters--sheet]="filtersSheetOpen()">
    <div class="solutions-people-browse__sheet-head">
      <h2 class="solutions-people-browse__sheet-title">
        {{ 'solutions.filters.toggle' | translate }}
      </h2>
      <button
        type="button"
        class="solutions-people-browse__sheet-close"
        (click)="closeFiltersSheet()"
        [attr.aria-label]="'global.close' | translate">
        <i class="iconsax" icon-name="x"></i>
      </button>
    </div>
    <div class="solutions-people-browse__sheet-body">
      <pwj-filters-panel titleKey="solutions.filters.toggle" icon="filter-search">
        <pwj-solutions-people-filters />
      </pwj-filters-panel>
    </div>
  </aside>

  <div class="solutions-people-browse__main">
    <pwj-sorts-bar
      class="solutions-people-browse__sorts"
      variant="segmented"
      [sorts]="sortItems"
      translateKey="sorting.people."
      sortParamKey="sort"
      [haveInitializeTab]="false"
      [resultsCount]="profilesCount()"
      [showFiltersButton]="showFiltersTriggerOnSortBar()"
      (filtersClick)="onFiltersFromSortBar()" />
    <pwj-profile-cards-list
      class="solutions-people-browse__list"
      [filterType]="filterType()"
      [noContentMessageKey]="noContentMessageKey()" />
  </div>
</div>
